// extracted by mini-css-extract-plugin
module.exports = {"currentVersion":"VersionHistoryList_currentVersion__1d4pz","historyVersion":"VersionHistoryList_historyVersion__1ckJk"};